import axios, { AxiosRequestConfig } from 'axios'

import { ISlog, SlogParams } from '@/types/slog'

export const createLog = async (log: ISlog): Promise<ISlog> => {
  try {
    const response = await axios.post<ISlog>('slogs', log)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.slogs.createLog')
  }
}

export const getLogs = async (params: SlogParams): Promise<ISlog[]> => {
  const config: AxiosRequestConfig = {
    timeout: 1000 * 60 * 10, // 10 min
    params,
  }
  try {
    const response = await axios.get<ISlog[]>('slogs', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.slogs.getLogs')
  }
}
